import { render } from "./SendersEditComponent.vue?vue&type=template&id=b0e0ad00&scoped=true"
import script from "./SendersEditComponent.vue?vue&type=script&lang=js"
export * from "./SendersEditComponent.vue?vue&type=script&lang=js"

import "./SendersEditComponent.vue?vue&type=style&index=0&id=b0e0ad00&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0e0ad00"]])

export default __exports__